import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";

import {getAcceptAuthConfig, USER_APPLICATIONS_ENDPOINT} from "../../../api/api";
import ApplicationForm from "../Participant/ApplicationForm";

function DirectorApplicationFormCreate(props) {
    const {id} = useParams();
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);

    const [errors, setErrors] = useState(null);

    const [applicationData, setApplicationData] = useState(
        {
            education: "",
            experience: "",
            achievements: "",
            achievements_confirmation_file: "",
            skills: "",
            scientific_interests: "",
            expectations: "",
            other_comments: ""
        });

    const [applicationProjectsData, setApplicationProjectsData] = useState(() => {
        const applicationProjects = JSON.parse(localStorage.getItem('applicationProjects')) || [];
        const addedProjects = JSON.parse(localStorage.getItem('addedProjects')) || [];
        const newProjects = addedProjects.filter(project => !applicationProjects.some(appProject => appProject.id === project.id));
        return [...applicationProjects, ...newProjects];
    });

    useEffect(() => {
        localStorage.setItem('addedProjects', JSON.stringify(applicationProjectsData));
    }, [applicationProjectsData])

    const onSubmit = (e) => {
        e.preventDefault();

        setSubmitting(true);

        const formData = new FormData();

        formData.append("worker_id", id);
        formData.append("cv", JSON.stringify(applicationData));
        formData.append("achievements_confirmation_file", applicationData.achievements_confirmation_file);

        formData.append("projects_user", JSON.stringify(applicationProjectsData));
        applicationProjectsData.forEach(project => {
            if (project.file) {
                formData.append(project.id, project.file);
            }
        });

        axios
            .post(USER_APPLICATIONS_ENDPOINT, formData, getAcceptAuthConfig())
            .then(response => {
                localStorage.removeItem('application');
                navigate('../', {relative: "path"});
            })
            .catch(error => {
                setErrors(error.response?.data)
                console.error('Ошибка отправки заявки:', error);
            })
            .finally(() => {
                setSubmitting(false);
            });
    }

    return (
        <>
            <h3 className="mb-2">Подача заявки на участие</h3>
            <hr className="clearfix w-100 pb-0"/>

            <ApplicationForm type={"create"}
                             applicationData={applicationData} setApplicationData={setApplicationData}
                             applicationProjectsData={applicationProjectsData}
                             setApplicationProjectsData={setApplicationProjectsData}
                             errors={errors}
                             onSubmit={onSubmit} submitting={submitting}/>
        </>
    );
}

export default DirectorApplicationFormCreate;